var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-wrap"},[_c('div',{ref:"mapRef",staticClass:"map-box"})])
}
var staticRenderFns = []

export { render, staticRenderFns }